<template>
  <div class="menu">
    <div class="header-banner">
      <!-- <Banner title="My Orders" crumb="My Orders" /> -->

      <Cart />

      <!-- <div class="container">
        <div class="custom-button-wrap">
          <router-link to="/">
            <div class="custom-button green">Add More Items</div>
          </router-link>
          <div class="custom-button" :class="showObject" @click="clearCart">
            Clear Cart
          </div>
        </div>
      </div> -->

      <UserInfo />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src\
import { mapGetters, mapActions } from "vuex";
import { MenuService } from "../../services/items.service";
import { LocationId, CartData } from "../../services/storage.service";

import Banner from "../../components/Banner.vue";

import Cart from "./Cart.vue";
import UserInfo from "./UserInfo.vue";

export default {
  name: "Checkout",
  components: {
    Banner,
    Cart,
    UserInfo,
  },
  computed: {
    ...mapGetters(["cartItems"]),
    showObject: function () {
      return {
        hide: this.cartItems.length === 0,
      };
    },
  },
  methods: {
    ...mapActions(["clearCart", "setMinOrder"]),

    getMinOrder: function () {
      MenuService.getItems(1, parseInt(LocationId.getLocationId()))
        .then((data) => {
          this.setMinOrder(data.minimum_order);
        })
        .catch((err) => console.log(err));
    },
  },
  created() {
    window.scrollTo(0, 0);
    this.getMinOrder();
  },
};
</script>

<style lang="scss" scoped>
.custom-button-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .custom-button {
    &.green {
      background: #60b246;
      border-color: #60b246;
      &:hover {
        color: #fff;
      }
    }
    &.hide {
      display: none;
    }
  }
}
</style>
